;(function() {
  'use strict'

  Controller.$inject = ["clipboardService", "glDialog", "glPrefs", "quotaCellsService", "quotaCellStateService", "quotaTextService", "userService"];
  angular.module('app.core').component('quotaCard', {
    controller: Controller,
    templateUrl: 'quota-card.html',
    bindings: {
      quota: '<',
      plan: '<',
      questions: '<',
      tagCounts: '<',
      surveyId: '<',
      surveyTags: '<',
      responseCount: '<',
      collapseCommandSeq: '<',
      collapseCommandCollapsed: '<',
      onChange: '&',
      onCollapsedChange: '&',
      onDelete: '&',
    },
  })

  /* @ngInject */
  function Controller(
    clipboardService,
    glDialog,
    glPrefs,
    quotaCellsService,
    quotaCellStateService,
    quotaTextService,
    userService
  ) {
    var ctrl = this

    var prefs = glPrefs.create('quota-manager')
    var PREFS_OPTIONS = { user: true }
    var signature = null

    ctrl.paste = null
    ctrl.summary = null
    ctrl.derivedTitle = null
    ctrl.targetsRevision = 0

    ctrl.$onInit = onInit
    ctrl.$onChanges = onChanges
    ctrl.$doCheck = doCheck

    ctrl.onPasteChange = onPasteChange
    ctrl.toggleCollapsed = toggleCollapsed
    ctrl.copyCounterNames = copyCounterNames
    ctrl.openVariables = openVariables
    ctrl.refreshMenu = refreshMenu
    ctrl.clearTargets = clearTargets

    function onInit() {
      ctrl.isSSR = userService.isSSR()
      ctrl.collapsed = readCollapsed()
      notifyCollapsed()
      refreshSummary()
    }

    function onChanges(changes) {
      if (
        changes.quota ||
        changes.plan ||
        changes.questions ||
        changes.tagCounts
      ) {
        refreshSummary()
      }

      if (changes.quota || changes.questions) {
        refreshDerivedTitle()
      }

      if (changes.surveyId && !changes.surveyId.isFirstChange()) {
        ctrl.collapsed = readCollapsed()
        refreshSummary()
        notifyCollapsed()
      }

      if (
        changes.collapseCommandSeq &&
        !changes.collapseCommandSeq.isFirstChange()
      ) {
        setCollapsed(ctrl.collapseCommandCollapsed === true)
      }
    }

    function doCheck() {
      var next = buildSignature()
      if (next === signature) return

      signature = next

      if (ctrl.collapsed) refreshSummary()

      refreshDerivedTitle()
    }

    function buildSignature() {
      if (!ctrl.quota) return ''

      return [
        ctrl.quota.id,
        ctrl.quota.mode,
        ctrl.quota.name,
        _.map(ctrl.quota.variables, 'id').join(','),
        _.map(ctrl.quota.variables, 'displayName').join(','),
        (ctrl.questions || []).length,
      ].join('|')
    }

    function onPasteChange(paste) {
      ctrl.paste = paste || null
    }

    function toggleCollapsed() {
      setCollapsed(!ctrl.collapsed)
    }

    function setCollapsed(collapsed) {
      if (ctrl.collapsed === collapsed) return

      ctrl.collapsed = collapsed
      if (ctrl.collapsed) refreshSummary()

      writeCollapsed(ctrl.collapsed)
      notifyCollapsed()
    }

    function notifyCollapsed() {
      if (!ctrl.quota) return

      ctrl.onCollapsedChange({
        quotaId: ctrl.quota.id,
        collapsed: ctrl.collapsed,
      })
    }

    function readCollapsed() {
      if (!ctrl.surveyId || !ctrl.quota) return false

      var collapsedIds = prefs.get(getPrefsKey(), PREFS_OPTIONS)

      return _.isPlainObject(collapsedIds)
        ? collapsedIds[ctrl.quota.id] === true
        : false
    }

    function writeCollapsed(collapsed) {
      if (!ctrl.surveyId || !ctrl.quota) return

      var key = getPrefsKey()
      var stored = prefs.get(key, PREFS_OPTIONS)
      var collapsedIds = _.isPlainObject(stored) ? stored : {}

      if (collapsed) {
        collapsedIds[ctrl.quota.id] = true
      } else {
        delete collapsedIds[ctrl.quota.id]
      }

      prefs.set(key, collapsedIds, PREFS_OPTIONS)
    }

    function getPrefsKey() {
      return 'collapsed-' + ctrl.surveyId
    }

    function refreshSummary() {
      if (!ctrl.collapsed) {
        ctrl.summary = null
        return
      }

      ctrl.summary = buildSummary()
    }

    function buildSummary() {
      var cells = quotaCellsService.getCells(ctrl.quota, ctrl.questions)
      var counts = ctrl.tagCounts || {}

      var target = 0
      var achieved = 0
      var setCount = 0
      var blankCount = 0

      cells.forEach(function(cell) {
        achieved += counts[cell.counterName] || 0

        var cellTarget = ctrl.plan
          ? ctrl.plan.getTarget(ctrl.quota.id, cell.cellKey)
          : null

        if (_.isNumber(cellTarget)) {
          target += cellTarget
          setCount++
        } else {
          blankCount++
        }
      })

      var hasBlank = blankCount > 0
      var barTarget = hasBlank || !setCount ? null : target

      return {
        isBroken: quotaCellsService.isBroken(ctrl.quota, ctrl.questions),
        cellCount: cells.length,
        target: setCount ? target : null,
        hasBlank: hasBlank,
        achieved: achieved,
        state: quotaCellStateService
          .getState(barTarget, achieved)
          .toLowerCase(),
        fillPercent: quotaCellStateService.getFillPercent(barTarget, achieved),
        hasBar: quotaCellStateService.hasBar(barTarget),
      }
    }

    function refreshDerivedTitle() {
      ctrl.derivedTitle = null

      if (!ctrl.quota) return

      var derived = ctrl.quota.getDerivedName(ctrl.questions)
      if (derived === ctrl.quota.name) return

      ctrl.derivedTitle = derived
    }

    function openVariables() {
      // prettier-ignore
      var template = [
        '<gl-dialog class="quota-variables-dialog__dialog">',
          '<quota-variables-dialog ',
            'quota="quota" ',
            'plan="plan" ',
            'questions="questions" ',
            'tag-counts="tagCounts" ',
            'survey-tags="surveyTags" ',
            'response-count="responseCount" ',
            'on-apply="dialog.close($result)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]

      glDialog
        .show({
          template: template.join(' '),
          clickOutsideToClose: false,
          escapeToClose: true,
          locals: {
            quota: ctrl.quota,
            plan: ctrl.plan,
            questions: ctrl.questions,
            tagCounts: ctrl.tagCounts,
            surveyTags: ctrl.surveyTags,
            responseCount: ctrl.responseCount,
          },
        })
        .then(applyVariables)
        .catch(_.noop)
    }

    function applyVariables(result) {
      if (!result) return

      var structural = !!(result.added.length || result.removed.length)

      if (structural && ctrl.quota.isInterlocked() && ctrl.plan) {
        ctrl.plan.clearTargets(ctrl.quota.id)
      }

      result.removed.forEach(function(variable) {
        ctrl.quota.removeVariable(variable)
      })

      result.added.forEach(function(variable) {
        ctrl.quota.addVariable(variable)
      })

      ctrl.quota.name = result.name
      ctrl.onChange()
    }

    function refreshMenu() {
      ctrl.targetCount = getTargetCount()
    }

    function getTargetCount() {
      if (!ctrl.plan || !ctrl.quota) return 0

      return _.keys(ctrl.plan.targetSets[0].targets[ctrl.quota.id] || {}).length
    }

    function clearTargets() {
      var targetCount = getTargetCount()

      if (!targetCount) return

      glDialog
        .confirm(
          'Clear all ' +
            quotaTextService.pluralise(targetCount, 'target', 'targets') +
            ' in "' +
            ctrl.quota.name +
            '"?',
          'Every cell goes back to no limit. Collected counts are not affected.',
          {
            locals: {
              closeText:
                targetCount === 1 ? 'Clear target' : 'Clear all targets',
              cancelText: 'Cancel',
            },
          }
        )
        .then(function() {
          ctrl.plan.clearTargets(ctrl.quota.id)
          ctrl.targetsRevision++
          ctrl.onChange()

          refreshSummary()
        })
        .catch(_.noop)
    }

    function copyCounterNames() {
      var cells = quotaCellsService.getCells(ctrl.quota, ctrl.questions)

      var lines = cells.map(function(cell) {
        return (cell.counterName || '(no counter)') + '\t' + cell.label
      })

      var tsv = ['Counter name\tCell'].concat(lines).join('\n')

      clipboardService.copy(tsv, {
        toastMessage:
          'Copied ' +
          quotaTextService.pluralise(
            cells.length,
            'counter name',
            'counter names'
          ) +
          ' for "' +
          ctrl.quota.name +
          '"',
      })
    }
  }
})()
